import { Component, Input, ViewEncapsulation } from "@angular/core";

import type { WizardComponent } from "./wizard.component";

@Component({
  selector: "app-wizard-profile-steps",
  templateUrl: "./wizard-profile-steps.component.html",
  styleUrls: [
    "./wizard.component.layout-and-progress.scss",
    "./wizard.component.preferences-and-responsive.scss"
  ],
  encapsulation: ViewEncapsulation.None,
  host: { style: "display: contents" },
  standalone: false
})
export class WizardProfileStepsComponent {
  @Input({ required: true }) view!: WizardComponent;
}
